import React from "react";
import clsx from "clsx";

import { ReactComponent as EditIcon } from "../../../assets/svg/note.svg";
import { ReactComponent as RemoveIcon } from "../../../assets/svg/delete.svg";
import { IGroup } from "../../../state";

import styles from "./GroupClassList.module.scss";

type Props = {
  groups: IGroup[];
  displayClassName: boolean;
  onUpdateGroupName: (group: IGroup) => void;
  onDeleteGroupName: (id: number) => void;
};

const GroupClassList = ({
  groups,
  displayClassName,
  onUpdateGroupName,
  onDeleteGroupName,
}: Props) => {
  return (
    <div className={clsx("d-flex flex-column py-3", styles.wrapper)}>
      {groups.map(group => (
        <div
          key={group.id}
          className="d-flex align-items-center justify-content-between w-100 py-2"
        >
          <div>
            {displayClassName && (
              <span className={styles.className}>{group.klass.full_name}</span>
            )}
            <span className={styles.groupName}>{group.name}</span>
          </div>
          <div className="d-flex align-items-center">
            <EditIcon
              className={clsx(styles.icon, styles.edit)}
              onClick={() => onUpdateGroupName(group)}
            />
            <RemoveIcon
              className={clsx(styles.icon, styles.remove)}
              onClick={() => onDeleteGroupName(group.id)}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default GroupClassList;
